import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { PresenceStatusRemoteDto } from '../../../../../generated/signalR/presence-status-remote-dto';
import { PresenceStatusType } from '../../../../samwebDescription/samweb/contactStatus/presenceStatusType';
import { PresenceStatusValuesUpdated } from './presence-status.actions';

export interface PresenceStatusStateModel {
   presenceStates: { [ocsidPresenceType: string]: PresenceStatusRemoteDto };
}

@State<PresenceStatusStateModel>({
   name: 'presenceStatus',
   defaults: {
      presenceStates: {},
   },
})
@Injectable()
export class PresenceStatusState {
   private static getKeyForPresenceStatus(presenceId: string, type: number): string {
      return `${presenceId?.toLowerCase()}_${type}`;
   }

   @Selector([PresenceStatusState])
   public static getAllAvailablePresenceStates(state: PresenceStatusStateModel): { [p: string]: PresenceStatusRemoteDto } {
      return state.presenceStates;
   }

   private static getPresenceStateRawDataSelector(keyValue: string) {
      return createSelector([PresenceStatusState.getAllAvailablePresenceStates], (allPresenceStates: { [p: string]: PresenceStatusRemoteDto }) => {
         return allPresenceStates[keyValue];
      });
   }

   public static getPresenceStateSelector(ocsId: string, presenceType: number) {
      const key = PresenceStatusState.getKeyForPresenceStatus(ocsId, presenceType);
      return createSelector([PresenceStatusState.getPresenceStateRawDataSelector(key)], (rawPresenceData: PresenceStatusRemoteDto) => {
         const presenceState = rawPresenceData;
         const presenceStatus = presenceState ? PresenceStatusType.getPresenceStatusTypeByValue(presenceState.state) : PresenceStatusType.UNKNOWN;
         return {
            presenceState: presenceState,
            presenceStatus: presenceStatus,
         };
      });
   }

   @Action(PresenceStatusValuesUpdated)
   @ImmutableContext()
   public contactStatesUpdated(ctx: StateContext<PresenceStatusStateModel>, action: PresenceStatusValuesUpdated) {
      ctx.setState((state: PresenceStatusStateModel) => {
         action.presenceStates.forEach((presenceStates) => {
            if (_.isNil(presenceStates.state)) {
               delete state.presenceStates[PresenceStatusState.getKeyForPresenceStatus(presenceStates.presenceId, presenceStates.type)];
               return;
            }
            state.presenceStates[PresenceStatusState.getKeyForPresenceStatus(presenceStates.presenceId, presenceStates.type)] = presenceStates;
         });
         return state;
      });
   }
}
